export default function MySQL_POWER() {
  return (
    <div>
      <h2>MySQL_POWER</h2>    </div>
  );
}